<template>
  <div class="page">
    <el-tabs class="card-info shadow" type="border-card">
      <el-tab-pane label="车辆黑名单">
        <BaseSearch
          v-model="searchDataA"
          :formOptions="searchFormOptionA"
          @handleSearch="handleSearchA"
        >
        </BaseSearch>
        <el-button type="primary" size="mini" @click="addCar"
          >+ 新增车辆黑名单</el-button
        >
        <BaseTable
          ref="baseTableA"
          url="/admin/carBlacklist/index"
          :tableData.sync="tableDataA"
          :columns="columnsA"
          :searchParams="searchDataA"
          :paramsCepCallback="paramsCepCallbackA"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="delCar(row)"
              >删除</el-button
            >
            <el-button type="text" size="mini" @click="editCar(row)"
              >修改</el-button
            >
          </template>
        </BaseTable>

        <el-drawer
          title="车辆黑名单"
          :visible.sync="showCarDrawer"
          direction="rtl"
        >
          <div style="padding: 40px">
            <el-form
              ref="baseForm"
              :model="formDataCar"
              :rules="rules"
              labelWidth="100px"
              size="medium"
            >
              <el-form-item label="车牌号" prop="carNo">
                <el-input v-model="formDataCar.carNo" required></el-input>
              </el-form-item>
              <el-form-item label="车架号" prop="vin">
                <el-input v-model="formDataCar.vin"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="bz">
                <el-input type="textarea" v-model="formDataCar.bz"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSubmitCar">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="人员黑名单">
        <BaseSearch
          v-model="searchDataB"
          :formOptions="searchFormOptionB"
          @handleSearch="handleSearchB"
        ></BaseSearch>
        <el-button type="primary" size="mini" @click="addPerson"
          >+ 新增人员黑名单</el-button
        >
        <BaseTable
          ref="baseTableB"
          url="/admin/personBlacklist/index"
          :tableData.sync="tableDataB"
          :columns="columnsB"
          :searchParams="searchDataB"
          :paramsCepCallback="paramsCepCallbackB"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="delPerson(row)"
              >删除</el-button
            >
            <el-button type="text" size="mini" @click="editPerson(row)"
              >修改</el-button
            >
          </template>
        </BaseTable>

        <el-drawer
          title="人员黑名单"
          :visible.sync="showPersonDrawer"
          direction="rtl"
        >
          <div style="padding: 40px">
            <el-form
              ref="baseForm"
              :model="formDataPerson"
              :rules="rules"
              labelWidth="100px"
              size="medium"
            >
              <el-form-item label="名称" prop="personName">
                <el-input
                  v-model="formDataPerson.personName"
                  required
                ></el-input>
              </el-form-item>
              <el-form-item label="证件号" prop="cardNo">
                <el-input v-model="formDataPerson.cardNo"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="bz">
                <el-input
                  type="textarea"
                  v-model="formDataPerson.bz"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSubmitPerson"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-drawer>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  rules,
  searchFormOptionA,
  searchFormOptionB,
  columnsA,
  columnsB,
} from "./columns";
export default {
  data() {
    return {
      searchDataA: {},
      searchDataB: {},
      tableDataA: [],
      tableDataB: [],
      showCarDrawer: false,
      formDataCar: {},
      showPersonDrawer: false,
      formDataPerson: {},
    };
  },
  computed: {
    rules,
    searchFormOptionA,
    searchFormOptionB,
    columnsA,
    columnsB,
  },
  methods: {
    handleSearchA() {
      this.$refs.baseTableA.searchData();
    },
    // 搜索参数拦截
    paramsCepCallbackA(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
    handleSearchB() {
      this.$refs.baseTableB.searchData();
    },
    paramsCepCallbackB(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
    addCar() {
      this.formDataCar = {};
      this.showCarDrawer = true;
    },
    addPerson() {
      this.formDataPerson = {};
      this.showPersonDrawer = true;
    },
    onSubmitCar() {
      this.$api
        .post("admin/carBlacklist/save", this.formDataCar, "操作")
        .then(() => {
          this.showCarDrawer = false;
          this.$refs.baseTableA.searchData();
        });
    },
    onSubmitPerson() {
      this.$api
        .post("admin/personBlacklist/save", this.formDataPerson, "操作")
        .then(() => {
          this.showPersonDrawer = false;
          this.$refs.baseTableB.searchData();
        });
    },
    delCar(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .post("admin/carBlackList/del", { id: row.id }, "删除")
            .then(() => {
              this.$refs.baseTableA.searchData();
            });
        })
        .catch(() => {});
    },
    editCar(row) {
      this.formDataCar = row;
      this.showCarDrawer = true;
    },
    delPerson(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .post("admin/personBlackList/del", { id: row.id }, "删除")
            .then(() => {
              this.$refs.baseTableB.searchData();
            });
        })
        .catch(() => {});
    },
    editPerson(row) {
      this.formDataPerson = row;
      this.showPersonDrawer = true;
    },
  },
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;
}
</style>